import React from 'react'
import EditBlockButton from './Controls/EditBlockButton'
import TriviaQuizModal from './Modals/TriviaQuizModal/TriviaQuizModal'
import StartScreen from './Components/StartScreen/StartScreen'
import NoCover from './Components/NoCover/NoCover'
import './TriviaQuiz.scss'

class TriviaQuiz extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showModal: false,
        }
    }

    openModal = evt => {
        evt.preventDefault()
        this.setState({
            showModal: true,
        })
    }
    closeModal = () => {
        this.setState({
            showModal: false,
        })
    }

    render() {
        const {
            blockData: { struct, colorTheme, id },
            pagesData,
            onUpdate,
        } = this.props
        const { showModal } = this.state
        return (
            <div className="block trivia-quiz">
                <EditBlockButton onClick={this.openModal} />

                {Object.keys(struct).length && struct._settings.showCover ? (
                    <StartScreen struct={struct} backgroundColor={colorTheme} />
                ) : (
                    <NoCover />
                )}

                {showModal ? (
                    <TriviaQuizModal
                        data={{
                            pages: pagesData,
                            structure: struct,
                            colorTheme: colorTheme,
                            id,
                        }}
                        settings={{ max_width: 960, overlayClose: false }}
                        methods={{
                            closeModal: this.closeModal,
                            save: onUpdate,
                        }}
                    />
                ) : null}
            </div>
        )
    }
}

export default TriviaQuiz
